import { m, useReducedMotion } from "framer-motion";
import type { ComponentPropsWithoutRef } from "react";
import { imageReveal } from "./tokens";

/** Narrowed to the plain-img props we use — avoids framer's drag/animation
 *  handler types colliding with the native <img> DOM handler types. */
type RevealImageProps = Pick<
  ComponentPropsWithoutRef<"img">,
  "src" | "alt" | "className" | "sizes" | "width" | "height" | "loading" | "id" | "style"
>;

/**
 * Drop-in <img> replacement that reveals with an editorial clip-wipe + gentle
 * settle out of a slight zoom the first time it scrolls into view. clip-path is
 * applied to the element itself, so no wrapper is needed; place inside an
 * overflow-hidden frame when the parent has rounded corners. Renders a plain
 * <img> when the visitor prefers reduced motion.
 */
export function RevealImage({ loading = "lazy", ...props }: RevealImageProps) {
  const reduce = useReducedMotion();
  if (reduce) {
    return <img loading={loading} {...props} />;
  }
  return (
    <m.img
      loading={loading}
      variants={imageReveal}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "0px 0px -10% 0px" }}
      {...props}
    />
  );
}
